import { PDFDocument } from 'pdf-lib';

export async function cutPdfToSelectedPages(
   pdfBlob: Blob,
   pagesToKeep: number[]
): Promise<Blob> {
   if (pagesToKeep.length === 0) {
      throw new Error("No pages selected to keep");
   }

   const arrayBuffer = await pdfBlob.arrayBuffer();
   const pdfDoc = await PDFDocument.load(arrayBuffer);
   const totalPages = pdfDoc.getPageCount();

   const invalidPages = pagesToKeep.filter(p => p < 1 || p > totalPages);
   if (invalidPages.length > 0) {
      throw new Error(`Invalid page numbers: ${invalidPages.join(', ')}. PDF has ${totalPages} pages.`);
   }

   const uniquePages = [...new Set(pagesToKeep)].sort((a, b) => a - b);

   const newPdf = await PDFDocument.create();

   for (const pageNum of uniquePages) {
      const [copiedPage] = await newPdf.copyPages(pdfDoc, [pageNum - 1]);
      newPdf.addPage(copiedPage);
   }

   const pdfBytes = await newPdf.save();
   const blobBytes = new Uint8Array(pdfBytes);
   return new Blob([blobBytes], { type: 'application/pdf' });
}

export async function getPdfPageCount(pdfBlob: Blob): Promise<number> {
   const arrayBuffer = await pdfBlob.arrayBuffer();
   const pdfDoc = await PDFDocument.load(arrayBuffer);
   return pdfDoc.getPageCount();
}
